export default __webpack_public_path__ + "static/media/Trash_light.d3421321.svg";